module.exports = __webpack_public_path__ + "img/search-icon-light-gray.7f690145.svg";